import Api from '@/utils/Api'

/**
 * 报修API
 */
export default class FaultApi extends Api {

    static getClass () {
        if (!this.instance) {
            this.instance = new FaultApi();
        }
        return this.instance;
    }

    getDashboardOrderCnt = (param) => {
        return this.$mhttp.httpGet(this.$constant.API_NSC + 'order/getDashboardOrderCnt', null, null);
    }

    // 报修单查询
    findPages = (param) => {
        return this.$mhttp.httpGet(this.$constant.API_NSC + 'order/findPages', param, null);
    }

    // 报修单导出
    exportOrder = (param) => {
        return this.$mhttp.httpFileGet(this.$constant.API_NSC + 'order/exportOrder', param, null);
    }

    findOrderById = (id) => {
        return this.$mhttp.httpGet(this.$constant.API_NSC + 'order/findOrderById/' + id, null, null);
    }

    getFiles = (typeId, recordId) => {
        return this.$mhttp.httpGet(this.$constant.API_NSC + 'file/files/type/' + typeId + '/record/' + recordId, null, null);
    }

    // 报修单反馈后修改状态
    updateStatusByOrderid = (param) => {
        return this.$mhttp.httpGet(this.$constant.API_NSC + 'order/updateStatusByOrderid', param, null);
    }

    acceptOrder = (orderid) => {
        return this.$mhttp.httpGet(this.$constant.API_NSC + "orderRepair/acceptOrder/" + orderid, null, null);
    }

    // 维修人员“完成”报修单
    completeOrder = (orderid) => {
        return this.$mhttp.httpPost(this.$constant.API_NSC + "orderRepair/completeOrder/" + orderid, null, null);
    }

    saveOrUpdate = (param) => {
        return this.$mhttp.httpPost(this.$constant.API_NSC + 'orderRepair/saveOrUpdate', param, "application/json");
    }

    //根据工程师查再次报修信息
    findEvaluatfeedback = (param) => {
        return this.$mhttp.httpGet(this.$constant.API_NSC + 'orderRepair/evaluatfeedback', param, null);
    }

    //根据id获取评论反馈详情
    qryOrderFeedback = (param) => {
        return this.$mhttp.httpGet(this.$constant.API_NSC + 'orderFeedback/qryOrderFeedback', param, null);
    }
    // 转单
    changeOrder = (param) => {
        return this.$mhttp.httpPost(this.$constant.API_NSC + 'order/changeOrder', param, null);
    }
    // 保存评价回复消息
    saveOrUpdateReply = (param) => {
        return this.$mhttp.httpPost(this.$constant.API_NSC + 'OrderFeedbackReply/orderFeedbackReply/saveOrUpdate', param, "application/json");
    }
    //查询维修中评价列表
    getReplyInfoApi = (orderid) => {
        return this.$mhttp.httpGet(this.$constant.API_NSC + `OrderFeedbackReply/orderFeedbackReply/orderid/${orderid}`, null, null);
    }
}